module.exports = __webpack_public_path__ + "static/img/wdzt1-4.735cdc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-4.png
// module id = 851
// module chunks = 0